module.exports = __webpack_public_path__ + "static/media/strongher8_preview.20467577.jpg";